import React from "react";
import Table from "../../../../../common/element/Table";
import moment from "moment/moment";
const { Tr, Th, Td, THead, TBody } = Table;
const DataList = ({ data, handleSort, getAllinvitedData }) => {
  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200">
        <Table>
          <THead>
            <Tr>
              <Th>Checklist</Th>
              <Th>Client name</Th>
              <Th>Documents no.</Th>
              <Th>Status</Th>
              <Th>Completion rate</Th>
              <Th onClick={(e) => handleSort(e, "completion_date")}>
                <span className="flex items-center gap-1">
                  Completion date
                  <svg
                    className={`transform ${
                      getAllinvitedData.sort === "completion_date" &&
                      getAllinvitedData.order === "asc"
                        ? "rotate-180"
                        : ""
                    }`}
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
                      stroke="#475467"
                      stroke-width="1.333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              </Th>
            </Tr>
          </THead>
          <TBody>
            {data?.DocsReport?.length > 0 &&
              data?.DocsReport?.map((item, index) => {
                return (
                  <Tr key={index}>
                    <Td>{item?.checklist_name}</Td>
                    <Td>{item?.client_trading_name}</Td>
                    <Td>{item?.total_checklist_docs}</Td>
                    <Td>
                      <span
                        className={
                          item?.status == "Approved"
                            ? "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium"
                            :  item?.status === "	Action required"
                            ? "badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                            : item?.status === "Awaiting review"
                            ? "badge bg-blue-50 text-blue-800 py-0.5 px-2 rounded-lg font-normal"
                            : item?.status ==="Partial" ?
                            "badge text-gray-700 bg-gray-100 py-0.5 px-2 rounded-lg font-normal":
                             " badge bg-error-100 text-error-700 py-0.5 px-2 rounded-lg font-medium"
                        }
                      >
                        {item?.status}
                      </span>
                    </Td>
                    <Td className={"flex items-center gap-1	"}>
                      <div className="w-full bg-gray-200 rounded-full h-2.5 dark:bg-gray-700">
                        <div
                          className="bg-blue-600 h-2.5 rounded-full"
                          style={{
                            width: `${Number(item?.completion_rate)?.toFixed(
                              2
                            )}%`,
                          }}
                        ></div>
                      </div>
                      {`${Number(item?.completion_rate)?.toFixed(2)}%`}
                    </Td>
                    <Td>
                      {item?.completion_date
                        ? moment(item?.completion_date).format("DD/MM/YYYY")
                        : "-"}
                    </Td>
                  </Tr>
                );
              })}
          </TBody>
        </Table>
      </div>
    </React.Fragment>
  );
};
export default DataList;
